import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteBold = function SvgRteBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#5C5F62",
    d: "M8 5a1 1 0 00-1 1v12a1 1 0 001 1h4.5c2.481 0 4.5-1.165 4.5-4 0-1.698-.724-2.796-1.837-3.405C15.69 10.967 16 10.112 16 9c0-2.835-2.019-4-4.5-4H8zm1 2v4h3c1.379 0 2-.857 2-2s-.621-2-2-2H9zm0 6v4h4c1.379 0 2-.857 2-2s-.621-2-2-2H9z",
    clipRule: "evenodd"
  })));
};
var rteBold = SvgRteBold;

export { rteBold as default };
